import {
  ACCEPT_REJECT_DOMAIN,
  ACCEPT_REJECT_DOMAIN_FAILURE,
  ACCEPT_REJECT_DOMAIN_SUCCESS,
  DELETE_USER,
  DELETE_USER_FAILURE,
  DELETE_USER_SUCCESS,
  EDIT_INFLUENCER_USER,
  EDIT_INFLUENCER_USER_FAILURE,
  EDIT_INFLUENCER_USER_SUCCESS,
  GET_BLOOM_USER_LIST,
  GET_BLOOM_USER_LIST_FAILURE,
  GET_BLOOM_USER_LIST_SUCCESS,
  GET_BLOOMSUB_USER_LIST,
  GET_BLOOMSUB_USER_LIST_FAILURE,
  GET_BLOOMSUB_USER_LIST_SUCCESS,
  GET_DOMAIN_DETAILS,
  GET_DOMAIN_DETAILS_FAILURE,
  GET_DOMAIN_DETAILS_SUCCESS,
  GET_DOMAIN_INFO_LIST,
  GET_DOMAIN_INFO_LIST_FAILURE,
  GET_DOMAIN_INFO_LIST_SUCCESS,
  GET_DREAM_FAILURE,
  GET_DREAM_LIST,
  GET_DREAM_SUCCESS,
  GET_EDUCATION_FAILURE,
  GET_EDUCATION_LIST,
  GET_EDUCATION_SUCCESS,
  GET_ETHNICITY_FAILURE,
  GET_ETHNICITY_LIST,
  GET_ETHNICITY_SUCCESS,
  GET_FREE_USER_LIST,
  GET_FREE_USER_LIST_FAILURE,
  GET_FREE_USER_LIST_SUCCESS,
  GET_FREESUB_USER_LIST,
  GET_FREESUB_USER_LIST_FAILURE,
  GET_FREESUB_USER_LIST_SUCCESS,
  GET_HOBBIES_FAILURE,
  GET_HOBBIES_LIST,
  GET_HOBBIES_SUCCESS,
  GET_INTRESTED_FAILURE,
  GET_INTRESTED_LIST,
  GET_INTRESTED_SUCCESS,
  GET_INVITE_FRIENDS_LIST,
  GET_INVITE_FRIENDS_LIST_FAILURE,
  GET_INVITE_FRIENDS_LIST_SUCCESS,
  GET_MESSAGE_DETAILS,
  GET_MESSAGE_DETAILS_FAILURE,
  GET_MESSAGE_DETAILS_SUCCESS,
  GET_MESSAGE_LIST,
  GET_MESSAGE_LIST_FAILURE,
  GET_MESSAGE_LIST_SUCCESS,
  GET_MYSELF_FAILURE,
  GET_MYSELF_LIST,
  GET_MYSELF_SUCCESS,
  GET_PREMIUM_USER_LIST,
  GET_PREMIUM_USER_LIST_FAILURE,
  GET_PREMIUM_USER_LIST_SUCCESS,
  GET_PREMIUMSUB_USER_LIST,
  GET_PREMIUMSUB_USER_LIST_FAILURE,
  GET_PREMIUMSUB_USER_LIST_SUCCESS,
  GET_QUERY_DETAILS,
  GET_QUERY_DETAILS_FAILURE,
  GET_QUERY_DETAILS_SUCCESS,
  GET_QUERY_USER_LIST,
  GET_QUERY_USER_LIST_FAILURE,
  GET_QUERY_USER_LIST_SUCCESS,
  GET_RELATION_FAILURE,
  GET_RELATION_LIST,
  GET_RELATION_SUCCESS,
  GET_RELIGION_FAILURE,
  GET_RELIGION_LIST,
  GET_RELIGION_SUCCESS,
  GET_SUB_USER_LIST,
  GET_SUB_USER_LIST_FAILURE,
  GET_SUB_USER_LIST_SUCCESS,
  GET_SUBSCRIPTION_DETAILS,
  GET_SUBSCRIPTION_DETAILS_FAILURE,
  GET_SUBSCRIPTION_DETAILS_SUCCESS,
  GET_USER_DETAILS,
  GET_USER_DETAILS_FAILURE,
  GET_USER_DETAILS_SUCCESS,
  GET_USER_LIST,
  GET_USER_LIST_FAILURE,
  GET_USER_LIST_SUCCESS,
  GET_USERS_FEEDBACK_LIST,
  GET_USERS_FEEDBACK_LIST_FAILURE,
  GET_USERS_FEEDBACK_LIST_SUCCESS,
  OPEN_CLOSE_SUPPORT,
  OPEN_CLOSE_SUPPORT_FAILURE,
  OPEN_CLOSE_SUPPORT_SUCCESS,
  RESUME_SUSPEND_USER,
  RESUME_SUSPEND_USER_FAILURE,
  RESUME_SUSPEND_USER_SUCCESS,
  SEND_ADMIN_MESSAGE_RESPONSE,
  SEND_ADMIN_MESSAGE_RESPONSE_FAILURE,
  SEND_ADMIN_MESSAGE_RESPONSE_SUCCESS,
  SEND_ADMIN_QUERY_RESPONSE,
  SEND_ADMIN_QUERY_RESPONSE_FAILURE,
  SEND_ADMIN_QUERY_RESPONSE_SUCCESS,
} from '../Actiontype';

export const getFreeUserSubscription = userid => {
  if (!userid) {
    userid = { userId: '' };
  }
  return {
    payload: Object.keys(userid)
      .map(key => `${key}=${userid[key]}`)
      .join('&'),
    type: GET_FREESUB_USER_LIST,
  };
};

export const getFreeUserSubscriptionSuccess = response => ({
  payload: response.data,
  type: GET_FREESUB_USER_LIST_SUCCESS,
});

export const getFreeUserSubscriptionFailure = response => ({
  payload: response,
  type: GET_FREESUB_USER_LIST_FAILURE,
});

export const getFreeUser = () => ({
  type: GET_FREE_USER_LIST,
});

export const getFreeUserSuccess = response => ({
  payload: response.data,
  type: GET_FREE_USER_LIST_SUCCESS,
});
export const getFreeUserFailure = response => ({
  payload: response,
  type: GET_FREE_USER_LIST_FAILURE,
});

export const getBloomUserSubscription = userid => {
  if (!userid) {
    userid = { userId: '' };
  }
  return {
    payload: Object.keys(userid)
      .map(key => `${key}=${userid[key]}`)
      .join('&'),
    type: GET_BLOOMSUB_USER_LIST,
  };
};
export const getBloomUserSubscriptionSuccess = response => ({
  payload: response.data,
  type: GET_BLOOMSUB_USER_LIST_SUCCESS,
});
export const getBloomUserSubscriptionFailure = response => ({
  payload: response,
  type: GET_BLOOMSUB_USER_LIST_FAILURE,
});

export const getBloomUser = data => {
  if (!data) {
    data = { status: '' };
  }
  console.log('data :----->', data);
  return {
    payload: Object.keys(data)
      .map(key => `${key}=${data[key]}`)
      .join('&'),
    type: GET_BLOOM_USER_LIST,
  };
};

export const getBloomUserSuccess = response => ({
  payload: response.data,
  type: GET_BLOOM_USER_LIST_SUCCESS,
});

export const getBloomUserFailure = response => ({
  payload: response,
  type: GET_BLOOM_USER_LIST_FAILURE,
});

export const getPremiumUserSubscription = userid => {
  if (!userid) {
    userid = { userId: '' };
  }
  return {
    payload: Object.keys(userid)
      .map(key => `${key}=${userid[key]}`)
      .join('&'),
    type: GET_PREMIUMSUB_USER_LIST,
  };
};

export const getPremiumUserSubscriptionSuccess = response => ({
  payload: response.data,
  type: GET_PREMIUMSUB_USER_LIST_SUCCESS,
});

export const getPremiumUserSubscriptionFailure = response => ({
  payload: response,
  type: GET_PREMIUMSUB_USER_LIST_FAILURE,
});

export const getPremiumUser = userid => {
  if (!userid) {
    userid = { userId: '' };
  }
  return {
    payload: Object.keys(userid)
      .map(key => `${key}=${userid[key]}`)
      .join('&'),
    type: GET_PREMIUM_USER_LIST,
  };
};

export const getPremiumUserSuccess = response => ({
  payload: response.data,
  count: response.count,
  totalAmount: response.totalAmount,

  type: GET_PREMIUM_USER_LIST_SUCCESS,
});

export const getPremiumUserFailure = response => ({
  payload: response,
  type: GET_PREMIUM_USER_LIST_FAILURE,
});

export const getQueryUserlist = data => {
  if (!data) {
    data = { isActive: '', isNewSupport: '' };
  }
  return {
    payload: Object.keys(data)
      .map(key => `${key}=${data[key]}`)
      .join('&'),
    type: GET_QUERY_USER_LIST,
  };
};

export const getQueryUserlistSuccess = response => ({
  payload: response.data,
  type: GET_QUERY_USER_LIST_SUCCESS,
});

export const getQueryUserlistFailure = response => ({
  payload: response,
  type: GET_QUERY_USER_LIST_FAILURE,
});

export const getQueryDetails = data => ({
  payload: Object.keys(data)
    .map(key => `${key}=${data[key]}`)
    .join('&'),
  type: GET_QUERY_DETAILS,
});

export const getQueryDetailsSuccess = response => ({
  payload: response.data,
  type: GET_QUERY_DETAILS_SUCCESS,
});

export const getQueryDetailsFailure = response => ({
  payload: response,
  type: GET_QUERY_DETAILS_FAILURE,
});

export const getMessageDetails = data => ({
  payload: Object.keys(data)
    .map(key => `${key}=${data[key]}`)
    .join('&'),
  type: GET_MESSAGE_DETAILS,
});

export const getMessageDetailsSuccess = response => ({
  payload: response.data,
  type: GET_MESSAGE_DETAILS_SUCCESS,
});

export const getMessageDetailsFailure = response => ({
  payload: response,
  type: GET_MESSAGE_DETAILS_FAILURE,
});

export const sendAdminQueryResponse = data => ({
  payload: data,
  type: SEND_ADMIN_QUERY_RESPONSE,
});

export const sendAdminQueryResponseSuccess = response => ({
  payload: response.data,
  type: SEND_ADMIN_QUERY_RESPONSE_SUCCESS,
});

export const sendAdminQueryResponseFailure = response => ({
  payload: response,
  type: SEND_ADMIN_QUERY_RESPONSE_FAILURE,
});

export const sendAdminMessageResponse = data => ({
  payload: data,
  type: SEND_ADMIN_MESSAGE_RESPONSE,
});

export const sendAdminMessageResponseSuccess = response => ({
  payload: response.data,
  type: SEND_ADMIN_MESSAGE_RESPONSE_SUCCESS,
});

export const sendAdminMessageResponseFailure = response => ({
  payload: response,
  type: SEND_ADMIN_MESSAGE_RESPONSE_FAILURE,
});

export const getMessagelist = () => ({
  type: GET_MESSAGE_LIST,
});

export const getMessagelistSuccess = response => ({
  payload: response.data,
  type: GET_MESSAGE_LIST_SUCCESS,
});
export const getMessagelistFailure = response => ({
  payload: response,
  type: GET_MESSAGE_LIST_FAILURE,
});

export const getReligionlist = () => ({
  type: GET_RELIGION_LIST,
});

export const getReligionlistSuccess = response => ({
  payload: response.data,
  type: GET_RELIGION_SUCCESS,
});
export const getReligionlistFailure = response => ({
  payload: response,
  type: GET_RELIGION_FAILURE,
});

export const getEducationlist = () => ({
  type: GET_EDUCATION_LIST,
});

export const getEducationlistSuccess = response => ({
  payload: response.data,
  type: GET_EDUCATION_SUCCESS,
});
export const getEducationlistFailure = response => ({
  payload: response,
  type: GET_EDUCATION_FAILURE,
});

export const getMySelflist = () => ({
  type: GET_MYSELF_LIST,
});

export const getMySelflistSuccess = response => ({
  payload: response.data,
  type: GET_MYSELF_SUCCESS,
});

export const getMySelflistFailure = response => ({
  payload: response,
  type: GET_MYSELF_FAILURE,
});

export const getHobbieslist = () => ({
  type: GET_HOBBIES_LIST,
});

export const getHobbieslistSuccess = response => ({
  payload: response.data,
  type: GET_HOBBIES_SUCCESS,
});
export const getHobbieslistFailure = response => ({
  payload: response,
  type: GET_HOBBIES_FAILURE,
});

export const getInterstedlist = () => ({
  type: GET_INTRESTED_LIST,
});

export const getInterstedlistSuccess = response => ({
  payload: response.data,
  type: GET_INTRESTED_SUCCESS,
});
export const geInterstedlistFailure = response => ({
  payload: response,
  type: GET_INTRESTED_FAILURE,
});

export const getRelationlist = () => ({
  type: GET_RELATION_LIST,
});

export const getRelationlistSuccess = response => ({
  payload: response.data,
  type: GET_RELATION_SUCCESS,
});
export const geRelationlistFailure = response => ({
  payload: response,
  type: GET_RELATION_FAILURE,
});

export const getDreamlist = () => ({
  type: GET_DREAM_LIST,
});

export const getDreamlistSuccess = response => ({
  payload: response.data,
  type: GET_DREAM_SUCCESS,
});
export const geDreamlistFailure = response => ({
  payload: response,
  type: GET_DREAM_FAILURE,
});

export const getUserlist = userid => {
  if (!userid) {
    userid = { gender: '' };
  }
  return {
    payload: Object.keys(userid)
      .map(key => `${key}=${userid[key]}`)
      .join('&'),
    type: GET_USER_LIST,
  };
};

export const getUserlistSuccess = response => {
  console.log(response);
  return {
    payload: response.data,
    userCount: response.userCount,
    filter: response.filter,
    type: GET_USER_LIST_SUCCESS,
  };
};
export const getUserlistFailure = response => ({
  payload: response,
  type: GET_USER_LIST_FAILURE,
});

export const getSubUserlist = () => ({
  type: GET_SUB_USER_LIST,
});
export const getSubUserlistSuccess = response => ({
  payload: response.data,
  type: GET_SUB_USER_LIST_SUCCESS,
});
export const getSubUserlistFailure = response => ({
  payload: response,
  type: GET_SUB_USER_LIST_FAILURE,
});

export const getUsersFeedbackList = response => ({
  type: GET_USERS_FEEDBACK_LIST,
});

export const getUsersFeedbackSuccess = response => ({
  payload: response,
  type: GET_USERS_FEEDBACK_LIST_SUCCESS,
});
export const getUsersFeedbackFailure = response => ({
  payload: response,
  type: GET_USERS_FEEDBACK_LIST_FAILURE,
});

export const getInviteFriendsList = response => ({
  type: GET_INVITE_FRIENDS_LIST,
});

export const getInviteFriendsSuccess = response => ({
  payload: response,
  type: GET_INVITE_FRIENDS_LIST_SUCCESS,
});
export const getInviteFriendsFailure = response => ({
  payload: response,
  type: GET_INVITE_FRIENDS_LIST_FAILURE,
});

export const getUserDetails = userid => ({
  payload: userid,
  type: GET_USER_DETAILS,
});
export const getUserDetailsSuccess = response => ({
  payload: response.data,
  subscribdata: response.subscription,
  type: GET_USER_DETAILS_SUCCESS,
});
export const getUserDetailsFailure = response => ({
  payload: response,
  type: GET_USER_DETAILS_FAILURE,
});

export const getSubscriptionDetails = userid => ({
  payload: userid,
  type: GET_SUBSCRIPTION_DETAILS,
});
export const getSubscriptionDetailsSuccess = response => ({
  payload: response.data,
  subscribdata: response.subscription,
  type: GET_SUBSCRIPTION_DETAILS_SUCCESS,
});
export const getSubscriptionDetailsFailure = response => ({
  payload: response,
  type: GET_SUBSCRIPTION_DETAILS_FAILURE,
});

export const deleteUser = userid => ({
  payload: userid,
  type: DELETE_USER,
});
export const deleteUserSuccess = response => ({
  payload: response,
  type: DELETE_USER_SUCCESS,
});
export const deleteUserFailure = response => ({
  payload: response,
  type: DELETE_USER_FAILURE,
});

export const getDomainInfolist = userid => {
  if (!userid) {
    userid = { status: '' };
  }
  return {
    payload: Object.keys(userid)
      .map(key => `${key}=${userid[key]}`)
      .join('&'),
    type: GET_DOMAIN_INFO_LIST,
  };
};

export const getDomainInfolistSuccess = response => ({
  payload: response.data,
  type: GET_DOMAIN_INFO_LIST_SUCCESS,
});
export const getDomainInfolistFailure = response => ({
  payload: response,
  type: GET_DOMAIN_INFO_LIST_FAILURE,
});

export const getDomainDetails = data => ({
  payload: Object.keys(data)
    .map(key => `${key}=${data[key]}`)
    .join('&'),
  type: GET_DOMAIN_DETAILS,
});
export const getDomainDetailsSuccess = response => ({
  payload: response.data,
  type: GET_DOMAIN_DETAILS_SUCCESS,
});
export const getDomainDetailsFailure = response => ({
  payload: response,
  type: GET_DOMAIN_DETAILS_FAILURE,
});

export const EditInfluencerUser = data => ({
  payload: data,
  type: EDIT_INFLUENCER_USER,
});
export const EditInfluencerUserSuccess = response => ({
  payload: response,
  type: EDIT_INFLUENCER_USER_SUCCESS,
});
export const EditInfluencerUserFailure = response => ({
  payload: response,
  type: EDIT_INFLUENCER_USER_FAILURE,
});

export const acceptRejectDomain = data => ({
  payload: data,
  type: ACCEPT_REJECT_DOMAIN,
});
export const acceptRejectDomainSuccess = response => ({
  payload: response,
  type: ACCEPT_REJECT_DOMAIN_SUCCESS,
});
export const acceptRejectDomainFailure = response => ({
  payload: response,
  type: ACCEPT_REJECT_DOMAIN_FAILURE,
});

export const resumeSuspendUser = data => ({
  payload: Object.keys(data)
    .map(key => `${key}=${data[key]}`)
    .join('&'),
  type: RESUME_SUSPEND_USER,
});

export const resumeSuspendUserSuccess = response => ({
  payload: response,
  type: RESUME_SUSPEND_USER_SUCCESS,
});
export const resumeSuspendUserFailure = response => ({
  payload: response,
  type: RESUME_SUSPEND_USER_FAILURE,
});

export const openCloseSupport = data => ({
  payload: Object.keys(data)
    .map(key => `${key}=${data[key]}`)
    .join('&'),
  type: OPEN_CLOSE_SUPPORT,
});

export const openCloseSupportSuccess = response => ({
  payload: response,
  type: OPEN_CLOSE_SUPPORT_SUCCESS,
});
export const openCloseSupportFailure = response => ({
  payload: response,
  type: OPEN_CLOSE_SUPPORT_FAILURE,
});

export const getEthnicitylist = () => ({
  type: GET_ETHNICITY_LIST,
});

export const getEthnicitylistSuccess = response => ({
  payload: response.data,
  type: GET_ETHNICITY_SUCCESS,
});
export const getEthnicityFailure = response => ({
  payload: response,
  type: GET_ETHNICITY_FAILURE,
});
